import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Form, Spinner } from "react-bootstrap";
import { FaEdit, FaTrash, FaPlus, FaEye, FaHistory } from "react-icons/fa";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import api from "../services/api";
import "./CustomerList.css";

const SupplierList = () => {
  const [search, setSearch] = useState("");
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const fetchSuppliers = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.post("/supplier_list.php", {});
      
      if (response.data.head.code === 200) {
        const transformedData = response.data.body.map(supplier => ({
          id: supplier.id,
          name: supplier.name,
          mobile: supplier.mobile,
          gst_number: supplier.gst_no,
          state: supplier.state,
          city: supplier.city,
          pin_code: supplier.pin_code,
          address: supplier.address
        }));
        
        setSuppliers(transformedData);
      } else {
        setError(response.data.head.msg || "Failed to fetch suppliers");
      }
    } catch (err) {
      console.error("Error fetching suppliers:", err);
      setError("Failed to load suppliers. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Are you sure you want to delete ${name}?`)) {
      return;
    }

    try {
      const response = await api.post("/supplier_delete.php", { id });
      
      if (response.data.head.code === 200) {
        setSuppliers(suppliers.filter((s) => s.id !== id));
        alert("Supplier deleted successfully!");
      } else {
        alert("Failed to delete supplier: " + response.data.head.msg);
      }
    } catch (err) {
      console.error("Error deleting supplier:", err);
      alert("Failed to delete supplier. Please try again.");
    }
  };

  const filteredSuppliers = suppliers.filter((s) => {
    if (!search) return true;
    const query = search.toLowerCase();
    return (
      String(s.id).toLowerCase().includes(query) ||
      (s.name && s.name.toLowerCase().includes(query)) ||
      (s.state && s.state.toLowerCase().includes(query)) ||
      (s.city && s.city.toLowerCase().includes(query)) ||
      (s.mobile && s.mobile.includes(query)) ||
      (s.gst_number && s.gst_number.toLowerCase().includes(query))
    );
  });

  const {
    currentPage,
    totalPages,
    currentItems: currentSuppliers,
    handlePageChange,
    indexOfFirstItem
  } = usePagination(filteredSuppliers, 10);

  if (loading) {
    return (
      <Container fluid className="outer-container my-3">
        <h2 className="text-center mb-3">Supplier Management</h2>
        <div className="text-center py-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">Loading suppliers...</p>
        </div>
      </Container>
    );
  }
{/*
  if (error) {
    return (
      <Container fluid className="outer-container my-3">
        <h2 className="text-center mb-3">Supplier Management</h2>
        <div className="alert alert-danger" role="alert">
          {error}
          <button className="btn btn-sm btn-outline-danger ms-3" onClick={fetchSuppliers}>
            Retry
          </button>
        </div>
      </Container>
    );
  }

  if (!loading && suppliers.length === 0) {
  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Supplier Management</h2>
      <div className="alert alert-info text-center">
        No suppliers found.
        <button className="btn btn-sm btn-outline-primary ms-3" onClick={fetchSuppliers}>
          Refresh
        </button>
      </div>
    </Container>
  );
}
*/}

  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Supplier Management</h2>
      
      <Row className="mb-3 align-items-center">
        <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
          <Form.Control
            placeholder="Search by name, mobile"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>

        <Col xs={12} md={6} lg={8} className="d-flex justify-content-md-end">
          <Link
            to="/addsupplier"
            className="btn-top d-inline-flex align-items-center"
          >
            <FaPlus className="me-2" /> Add Supplier
          </Link>
        </Col>
      </Row>

      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped customer-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Supplier Name</th>
                <th>Mobile</th>
                {/* <th>GST Number</th>
                <th>State</th>
                <th>City</th>
                <th>Pin Code</th>
                <th>Order History</th> */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentSuppliers.map((supplier, index) => (
                <tr key={supplier.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{supplier.name}</td>
                  <td>{supplier.mobile}</td>
                  {/* <td>{supplier.gst_number || "N/A"}</td>
                  <td>{supplier.state}</td>
                  <td>{supplier.city || "N/A"}</td>
                  <td>{supplier.pin_code || "N/A"}</td>
                  <td>
                    <Link
                      to={`/supplierorders/${supplier.id}`}
                      className="order-history-link"
                      title="View Order History"
                    >
                      <FaHistory className="history-icon" />
                    </Link>
                  </td> */}
                  <td>
                    <div className="action-icons">
                      {/* <Link
                        to={`/viewsupplier/${supplier.id}`}
                        className="me-2"
                        title="View Supplier"
                      >
                        <FaEye className="view-icon" />
                      </Link> */}
                      <Link
                        to={`/editsupplier/${supplier.id}`}
                        className="me-2"
                        title="Edit Supplier"
                      >
                        <FaEdit className="edit-icon" />
                      </Link>
                      <FaTrash
                        className="delete-icon"
                        title="Delete Supplier"
                        onClick={() => handleDelete(supplier.id, supplier.name)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {currentSuppliers.length === 0 && (
                <tr>
                  <td colSpan="9" className="text-center">
                    {search ? "No suppliers found matching your search" : "No suppliers found"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
};

export default SupplierList;